var map = {
	"./arrow-down.svg": 25323,
	"./arrow-outward.svg": 70360,
	"./arrow-up.svg": 3981,
	"./audio-backward.svg": 18167,
	"./audio-forward.svg": 58189,
	"./audio-music.svg": 93669,
	"./audio-outline.svg": 99595,
	"./audio-pause.svg": 4645,
	"./audio-play.svg": 24832,
	"./audio-replay.svg": 74387,
	"./author-icon.svg": 54080,
	"./back-icon.svg": 74681,
	"./biggan-chinta.svg": 28291,
	"./bondhushava.svg": 43006,
	"./bookmark-outline.svg": 78411,
	"./calendar.svg": 67554,
	"./clear-input.svg": 2250,
	"./close-bold.svg": 30922,
	"./close-white.svg": 36641,
	"./close.svg": 39525,
	"./comments-outline.svg": 53045,
	"./default-author-image.svg": 39191,
	"./default-card-image.svg": 31763,
	"./edit-outline.svg": 30133,
	"./envelope.svg": 18163,
	"./fb-blue.svg": 46158,
	"./fb-whitebg.svg": 70238,
	"./fb.svg": 33836,
	"./fullscreen-exit.svg": 25291,
	"./fullscreen.svg": 65204,
	"./gallery-scope.svg": 62384,
	"./globe.svg": 30308,
	"./google-g.svg": 13308,
	"./google-icon.svg": 20557,
	"./half-rising-sun.svg": 33227,
	"./hamburger.svg": 62303,
	"./input-down.svg": 43500,
	"./interview-outline.svg": 41075,
	"./kishoralo-white.svg": 13935,
	"./kishoralo.svg": 2992,
	"./launcher.svg": 55151,
	"./list-close.svg": 54989,
	"./list-open.svg": 24968,
	"./location.svg": 68767,
	"./media-placeholder.svg": 86034,
	"./messenger.svg": 10255,
	"./nagorik.svg": 64918,
	"./newspaper.svg": 17675,
	"./next-story.svg": 67641,
	"./palo-bangla.svg": 89249,
	"./palo-english.svg": 81993,
	"./pause.svg": 3265,
	"./photo-camera.svg": 83827,
	"./photo-outline.svg": 49920,
	"./pinned-icon.svg": 60466,
	"./play.svg": 85907,
	"./prayer-header.svg": 20975,
	"./prayer-sunrise.svg": 69173,
	"./prothomalo-com.svg": 79055,
	"./prothomalo-trust.svg": 63462,
	"./protichinta-logo.svg": 95221,
	"./refresh-icon.svg": 35448,
	"./search-white.svg": 3258,
	"./search.svg": 66759,
	"./shorts-outline.svg": 39642,
	"./shorts.svg": 67728,
	"./sponsor.svg": 8798,
	"./star.svg": 30816,
	"./sun.svg": 74060,
	"./tv.svg": 29145,
	"./twitter-whitebg.svg": 98762,
	"./user.svg": 76781,
	"./video-outline.svg": 97902,
	"./video-play.svg": 58645,
	"./visual-story-outline.svg": 86983,
	"./visual-story.svg": 76221,
	"./youtube-fill.svg": 72189,
	"./youtube-outline.svg": 94357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51006;